// src/api/contactApi.js
import apiClient from './axios';

const contactApi = {
  // getAll: async (page = 1, pageSize = 10, search = '', is_active) => {
  //   const response = await apiClient.get('/new-contact/', {
  //     params: { page, page_size: pageSize, search, is_active },
  //   });
  //   return response.data;
  // },

// src/api/contactApi.js

getAll: async (
  page = 1, 
  pageSize = 10, 
  search = '', 
  is_active = null, 
  createdBy = null,
  label = null
) => {
  const params = { page, page_size: pageSize, search };
  
  if (is_active !== null && is_active !== undefined) {
    params.is_active = is_active;
  }
  if (createdBy && createdBy !== 'all') {
    params.created_by = createdBy;
  }
  // ✅ ADD: Pass label parameter
  if (label && label !== 'all' && label !== 'none') {
    params.label = label;
  }
  // Optional: Handle "no label" filter
  if (label === 'none') {
    params.label = 'none'; // or params.has_no_label = true (depending on your backend)
  }
  
  const response = await apiClient.get('/new-contact/', { params });
  return response.data;
},

  create: async (formData) => {
    const response = await apiClient.post('/new-contact/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  update: async (id, formData) => {
    const response = await apiClient.patch(`/new-contact/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/new-contact/${id}/`);
    return id;
  },

  exportCsv: async () => {
    const response = await apiClient.get('/new-contact/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/new-contact/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importConfirm: async (preview) => {
    const response = await apiClient.post('/new-contact/import-confirm/', { preview });
    return response.data;
  },
};

export default contactApi;